import RestService from "model/service/dataStorage/RestService";
import IRestServiceOptions from "../../interface/api/IRestServiceOptions";
import IRestServiceCollectionResponse from "../../interface/api/IRestServiceCollectionResponse";
import ICompany from "../../interface/company/ICompany";
import IPresenter from "../../interface/dataStorage/IPresenter";
import IRepositoryService from "../../interface/IRepositoryService";
import IField from "../../interface/dataStorage/IField";
import IRestServiceChoiceListResponse from "../../interface/api/IRestServiceChoiceListResponse";

interface IRestCompaniesServiceCollectionResponse extends IRestServiceCollectionResponse {
    results: Array<ICompany>
}

interface IRestCompaniesService extends IRepositoryService {
    collectionList(options?: IRestServiceOptions): Promise<IRestCompaniesServiceCollectionResponse>,

    collectionCreate(data: any): Promise<ICompany>,

    resourceRetrieve(id: number | string): Promise<ICompany>,

    resourceUpdate(id: number | string, data: any): Promise<ICompany>,

    resourceDelete(id: number | string): Promise<void>,
}

const CompaniesService_COLLECTION = 'company/companies'
const CompaniesService_CHOICES = 'company/companies-choices/'

class CompaniesService implements IRestCompaniesService {
    private static instance?: CompaniesService

    public static getInstance(): CompaniesService {
        if (!CompaniesService.instance) {
            CompaniesService.instance = new CompaniesService()
        }
        return CompaniesService.instance
    }

    getFields(): IField[] {
        // TODO
        return [
            {
                uuid: '',
                name: 'name',
                mode: "scalar",
                type: 'string',
                label: 'Název',
                targetEntity: null,
                options: [],
                weight: 1,
                contentTypeId: null,
                contentTypeName: false,
                locked: true,
                arguments: {}
            }
        ];
    }
    getRecordClassName() {
        return 'App\\Company\\Entity\\Company'
    }
    getTitle(): string {
        return "Společnost";
    }
    collectionList(options?: IRestServiceOptions): Promise<IRestCompaniesServiceCollectionResponse> {
        return RestService.collectionList(CompaniesService_COLLECTION, options as unknown as IRestServiceOptions) as Promise<IRestCompaniesServiceCollectionResponse>
    }
    collectionCreate(data: any) {
        return RestService.collectionCreate(CompaniesService_COLLECTION, data) as Promise<ICompany>
    }
    resourceRetrieve(id: number | string, options?: IRestServiceOptions) {
        return RestService.resourceRetrieve(CompaniesService_COLLECTION, id) as Promise<ICompany>
    }
    resourceDelete(id: number | string) {
        return RestService.resourceDelete(CompaniesService_COLLECTION, id)
    }
    resourceUpdate(id: number | string, data: any) {
        return RestService.resourceUpdate(CompaniesService_COLLECTION, id, data) as Promise<ICompany>
    }
    getStringValue(company: ICompany): string {
        return company.name
    }
    getPresenter(name: string): IPresenter | null {
        return this.getDefaultPresenter()
    }
    getDefaultPresenter(): IPresenter {
        return {
            type: 'label',
            name: 'default',
            label: 'Výchozí',
            options: {
                label: "#name"
            }
        } as IPresenter
    }
    getPresenterList() {
        //TODO ADD PRESENTERS ?
        return [this.getDefaultPresenter()].map(presenter => {return {value: presenter.name, label: presenter.label}})
    }
    choiceList(presenterName: string, options?: IRestServiceOptions): Promise<IRestServiceChoiceListResponse> {
        return RestService.collectionList(CompaniesService_CHOICES + presenterName, options) as unknown as Promise<IRestServiceChoiceListResponse>
    }
}

export default CompaniesService